export default {
    title: "",
    unavailable: "Este produto não está mais disponível."
}